export const faq = {
  question1: "ما هو موبيلاوي؟",
  answer1:
    "موبيلاوي هو برنامج الولاء تقدمه اكسون موبيل مصر لعملائها والذي يمنح لكل عميل الحق في تجميع نقاط عند قيامه بملئ سيارته بوقود موبيل سوبر بلس 95 بحد ادني 25 لتر أو استخدام زيوت موبيل، ثم يستطيع العميل استخدام نقاطه المجمعة كوسيلة سداد بديلة سواء كلية أو جزئٌية عند شرائه لأي من المنتجات و/أو الخدمات المتوفره داخل أى فرع من فروع مقدمى الخدمات المشتركين فى البرنامج داخل جمهورية مصر العربية.",
  question2: "ما هي أنواع الزيوت و محطات الوقود المشتركة في البرنامج؟",
  answer2: {
    participatingStation: "المحطات المشاركة في البرنامج",
    zayed: "الشيخ زايد",
    zamalek: "الزملك",
    wBalad: "وسط البلد",
    urban1: "التجمع الخامس البنفسج-",
    tagamoa: "التجمع الخامس",
    sphinx: "طريق القاهرة الاسكندرية الصحراوي",
    smoha: "سموحة",
    shatby: "الشاطبي",
    sadat: "السادات أكاديمي",
    roxy: "روكسي",
    roshdy: "رشدي",
    rehab: "الرحاب",
    orouba: "العروبة",
    october: "مدينة 6 اكتوبر",
    oboroie: "اوبروي",
    nozha: "النزهة",
    nour: "النور",
    newMaadi: "المعادي الجديدة",
    nasrRoad: "طريق النصر",
    narges: "النرجس- التجمع الخامس",
    mohandessin: "المهندسين",
    merghem: "ميرغم- طريق القاهرة الاسكندرية الصحراوي",
    merghany: "المرغني-مصر الجديدة",
    mariottya: "المريوطية",
    marina: "مارينا",
    manial: "المنيل",
    madinty: "مدينتي",
    maadiTowers: "المعادى",
    ibrahimeya: "ابراهيمية",
    hegaz: "مصر الجديدة",
    hassanElMaamoun: "حسن المأمون",
    gametElDowal: "المهندسين",
    fardous: "السادس من أكتوبر",
    dokki: "الدقي",
    cornich: "كورنيش النيل",
    concordPlaze: "كونكورد بلاازا-التجمع الخامس",
    batal: "المهندسين",
    bakry: "البكري",
    autostrad: "اوتوستراد",
    amreya: "العامرية",
    almaza: "الماظة",
    runway: "الأسكندرية - رانواي",
    airport: "المطار",
    agouza: "العجوزة",
    newCairo: "القاهرة الجديدة",
  },
  question3: "كيف أقوم بتجميع النقاط عند استخدامي لزيوت موبيل مصر؟",
  answer3: {
    remove: "انزع الملصق الأمامي الموجود على وجه العبوة.",
    accumulate: "قم بتجميع النقاط عن طريق:",
    application: "التطبيق: إمسح ال QR كود أو أدخل الكود على التطبيق",
    send: "رسالة نصية: أرسل الكود في رسالة نصية قصيرة إلى 4432",
    receive:
      "ستتلقى رسالة نصية قصيرة عبر هاتفك المحمول متضمنة رصيد نقاطك الحالي",
  },
  question4: "كيف أقوم بتجميع النقاط عند قيامي بملئ سيارتي بوقود موبيل بلس 95؟",
  answer4: {
    visit:
      "عند قيامك بزيارة محطات موبيل المشتركة في البرنامج والتي يوجد بها  On The Runأو The Way To Go أو علامة موبيلاوي لملئ سيارتك بحد أدني خمسه وعشرين لتر أو أكثر من بنزين موبيل سوبر بلس 95",
    show: "أظهر لعامل محطة موبيل ال QR كود تطبيق موبيلاوي ليقوم العامل لدى محطة موبيل بمسح الكود على المحمول الخاص بك",
    once: "ستتلقى رسالة نصية قصيرة عبر هاتفك المحمول متضمنة رصيد نقاطك الحالي",
    provide:
      "يقوم العامل باعطاءك المحمول المخصص للبرنامج لكي تقوم بادخال رقم المحمول الخاص بك",
    amount:
      "سيقوم عامل محطة موبيل بإضافة خمسة وعشرين لتر أو أكثر التي قمت باستخدامها على المحمول الخاص بالمحطة وذلك بهدف اضافة النقط إلي حسابك.",
    receive:
      "ثم يتم ارسال رسالة نصية قصيرة عبر هاتفك المحمول متضمنة رصيد نقاطك الحالي ورابط للبوابة الالكترونية الخاصة بالبرنامج المرفق بالرسالة.",
  },
  question5: "كيف يمكنني التسجيل في أو الدخول على تطبيق موبيلاوي؟",
  answer5: {
    newAccount: "إذا كنت تقوم بإنشاء حساب جديد، يرجى اتباع الخطوات التالية:",
    download: "حمل تطبيق موبيلاوي من متجر جوجل بلاي/آب ستور",
    open: "أدخل علي صفحة التسجيل.",
    enter:
      "أدخل رقم هاتفك المحمول أو قم بالتسجيل باستخدام التواصل الاجتماعي، وسيصلك كود (OTP) عبر الرسائل النصية",
    otp: "أدخل الOTP",
    fullName: "أدخل اسمك ويمكنك إكمال باقي البيانات لاحقا",
    success:
      "بعد استكمال البيانات المطلوبة، سيتم تسجيلك بنجاح ويمكنك استخدام خدمات التطبيق",
    signOut: "تسجيل الخروج من التطبيق.",
    settings:
      "انتقل إلى إعدادات الهاتف المحمول، وتأكد من عدم إغلاق القياسات الحيوية والأمن من إعدادات التطبيق، يرجى التأكد من فتحها لتكون عملية تسجيل الدخول السهلة",
    logIn:
      "أدخل علي تطبيق موبيلاوي شاشة تسجيل الدخول، وسيظهر رمز بصمة الإصبع بجوار زر تسجيل الدخول مباشرةً",
    click:
      "اضغط على أيقونة بصمة الإصبع، وبذلك تتم عملية بصمة الإصبع/معرف الوجه بنجاح..",
    finger: "يمكنك تسجيل الدخول باستخدام بصمة الأصبع/ Face ID",
    existing:
      "إذا كنت تقوم بتسجيل الدخول باستخدام حساب موجود  بالفعل، يرجى اتباع الخطوات التالية:",
    enterSignIn:
      "أدخل رقم هاتفك المحمول أو قم بالتسجيل باستخدام التواصل الاجتماعي، وسيصلك كود (OTP) عبر الرسائل النصية",
    otpSignIn: "أدخل الOTP وسيتم تسجيل الدخول بنجاح",
    registered:
      "ادخل علي صفحة تسجيل الدخول، وأدخل رقم هاتفك المحمول المسجل وكلمة المرور",
    logout: "تسجيل الخروج من التطبيق.",
  },
  question6:
    "كيف أقوم بالاستفسار عن رصيد نقاطي، وقيمتها المالية و التعرف علي مقدمي الخدمات المشتركين في البرنامج؟",
  answer6: {
    logIn:
      "قم بتسجيل الدخول عبر التطبيق الخاص بالبرنامج أو البوابة الإلكترونية",
    success:
      "بعد تسجيل الدخول عبر التطبيق أو الموقع الإلكتروني يمكنك التعرف على رصيد نقاطك المكتسبة ومعرفة أسماء مقدمي الخدمات المشتركين في البرنامج",
    check:
      "يجب ان تقوم بتسجيل دخول عبر التطبيق الخاص بالبرنامج أو البوابة الالكترونية الخاصة بالبرنامج المرسلة في الرسالة النصية عن طريق اتباع الخطوات التالية:",
    existing: "عبر التطبيق: اذا كنت تمتلك حساب خاص بك",
    number: "ادخال رقم الهاتف المحمول الخاص بك",
    monitor:
      "مجرد نجاحك فى تسجيل الدخول عبر التطبيق فتتمكن من مراقبة رصيد نقاطك المكتسبة ومعرفة أسماء مقدمي الخدمات المشتركين فى البرنامج",
    new: "عبر التطبيق: اذا كنت تريد انشاء حساب خاص بك",
    otp: "ثم يتم ارسال رسالة نصية لك عبر الهاتف المحمول بها OTP/ كود",
    code: "ثم تقوم بادخال تلك الكود فى المكان المخصص له على التطبيق.",
    name: "ثم تقوم بأضافة الأسم و كلمة السر فى المكان المخصص له على التطبيق.",
    portal: "عبر الموقع لألكتروني",
    codePortal:
      "ثم تقوم بادخال تلك الكود فى المكان المخصص له على الموقع الألكتروني.",
    monitorPortal:
      "مجرد نجاحك فى تسجيل الدخول عبر الموقع الالكتروني فتتمكن من مراقبة رصيد نقاطك المكتسبة ومعرفة أسماء مقدمي الخدمات المشتركين فى البرنامج",
  },
  question7: "اين اقوم باستبدال نقاطي؟",
  answer7:
    "يمكننك معرفة شبكة التجار الخاصة بموبيلاوي عند قيامك بزيارة صفحة التجار من على التطبيق أو الموقع الالكتروني الخاص بالبرنامج",
  question8: "ما هي الخطوات التي يجب اتباعها من أجل استبدال نقاطي المجمعة؟",
  answer8: {
    visit:
      "توجه إلي اي فرع من فروع مقدمي الخدمة في جميع انحاء جمهورية مصر العربية",
    request:
      "اطلب استخدام نقاطك المكتسبة من موبيلاوي سواء كلية أو جزئية لاستكمال العملية الشرائية.",
    choose: "إختر المنتج أو الخدمة التى ترغب فى شراءها من مقدمي الخدمة.",
    provide:
      "قم باعطاء رقم المحمول الخاص بك الى موظفى مقدمى الخدمة لتحويل نقاطك الى ما يعادلها من مبلغ مالى يمكن استبداله.",
    otp: "ستتلقى رسالة نصية عبر الهاتف المحمول بها OTP",
    after:
      "بعد استخدام ال OTP كود من التاجر، ستتلقى رسالة نصية قصيرة تحتوي على رصيد نقاطك الحالي بعد خصم النقاط",
    pay: "وبالتالى تتمكن من سداد مقابل ما حصلت عليه من منتجات/خدمات عن طريق إستخدام النقاط المجمعة بحسابك",
  },
  question9: "هل يمكن استبدال النقاط بقيمة مالية؟",
  answer9: "لا يمكن استبدال النقاط بنقود مالية",
  question10: "ما هو الرقم الدعم و الاستفسارات؟",
  answer10: "15177",
};
